export const contextCategories = ['Context', 'Cohort', 'Study'];
export const contextSubtypeNames = ['People', 'Organizations', 'Locations', 'Events', 'Other'];
const tags = node => node.category_tags || [node.type];
const endpoint = value => typeof value === 'object' && value !== null ? value.id : value;

// Opening Context also opens its study/cohort context, without reclassifying nodes.
export function selectContextCategories(previous, next, available) {
  return !previous.includes('Context') && next.includes('Context')
    ? [...new Set([...next, ...available.filter(value => ['Study', 'Cohort'].includes(value))])]
    : next;
}

export function filterGraphView(data, { graphMode = 'network', selectedCategories = null, contextSubtypes = null } = {}) {
  const nodes = data.nodes.filter(node => {
    const categories = tags(node);
    if (graphMode === 'context' && !categories.some(tag => contextCategories.includes(tag))) return false;
    if (selectedCategories !== null && !categories.some(tag => selectedCategories.includes(tag))) return false;
    if (contextSubtypes !== null && categories.includes('Context')
      && !categories.some(tag => ['Study', 'Cohort'].includes(tag))) {
      const subtype = contextSubtypeNames.includes(node.context_subtype) ? node.context_subtype : 'Other';
      return contextSubtypes.includes(subtype);
    }
    return true;
  });
  const ids = new Set(nodes.map(node => node.id));
  return { nodes, links: data.links.filter(link => ids.has(endpoint(link.source)) && ids.has(endpoint(link.target))) };
}
